import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Skeleton компонент для строки проекта
const ProjectRowSkeleton = () => (
  <div className="grid grid-cols-4 gap-4 items-center border-b py-2 animate-pulse">
    <div className="h-4 bg-gray-300 rounded w-32"></div>
    <div className="h-4 bg-gray-300 rounded w-20"></div>
    <div className="h-4 bg-gray-300 rounded w-20"></div>
    <div className="h-8 bg-gray-300 rounded w-24"></div>
  </div>
);

function AllProjects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchf() {
      setLoading(true);
      try {
        const res = await fetch("https://time-api.web-hub.online/api/projects");
        const data = await res.json();
        
        setProjects(data?.results || []);
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchf();
  }, []);

  return (
    <div className="w-full max-w-[1480px] bg-white rounded-lg shadow-lg p-8">
      <div className="mb-6 text-3xl font-bold">All Projects</div>
      
      <div className="overflow-x-auto">
        <div className="min-w-full">
          <div className="grid grid-cols-4 gap-4 font-bold border-b pb-2 mb-4">
            <div>Project Name</div>
            <div>Available Time</div>
            <div>Current Time</div>
            <div>Actions</div>
          </div>

          {loading ? (
            // Skeleton loader
            <>
              <ProjectRowSkeleton />
              <ProjectRowSkeleton />
              <ProjectRowSkeleton />
              <ProjectRowSkeleton />
              <ProjectRowSkeleton />
            </>
          ) : (
            // Реальные данные
            projects.map((project) => (
              <div key={project.id} className="grid grid-cols-4 gap-4 items-center border-b py-2">
                <div>{project.properties?.Name?.title?.[0]?.plain_text || 'Unnamed Project'}</div>
                <div>{project.properties?.available_time?.rich_text?.[0]?.plain_text || '00:00:00'}</div>
                <div>{project.properties?.Time?.rich_text?.[0]?.plain_text || '00:00:00'}</div>
                <div className="flex gap-2">
                  <Link
                    to={`/customers/${project.id}`}
                    className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                  >
                    Go to Project
                  </Link>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default AllProjects;
